import { render, staticRenderFns } from "./KardexPagosUpi.vue?vue&type=template&id=3187b7e9"
import script from "./KardexPagosUpi.vue?vue&type=script&lang=js"
export * from "./KardexPagosUpi.vue?vue&type=script&lang=js"
import style0 from "./KardexPagosUpi.vue?vue&type=style&index=0&id=3187b7e9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports